import { render } from "./SeFadeButton.vue?vue&type=template&id=08250eb6&scoped=true&ts=true"
import script from "./SeFadeButton.vue?vue&type=script&lang=ts"
export * from "./SeFadeButton.vue?vue&type=script&lang=ts"

import "./SeFadeButton.vue?vue&type=style&index=0&id=08250eb6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08250eb6"]])

export default __exports__